import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Breadcrumb } from 'react-breadcrumbs'
import { get } from 'lodash'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { UserDetailsWrapper } from 'Components/UserManagement/UserDetailsWrapper'
import { UserManagementDetailsAddForm } from 'Containers/Form/UserManagement/UserDetails/Add'
import { createUser, updateUserById } from 'Reducers/Users/actions'
import { uploadProfileImage } from 'Reducers/Upload/actions'
import { isClientRole } from 'Utils/Validators/roles'
import UserManagementIcon from 'Assets/Images/icons/userManagement'
import { PATHS } from 'Config/Routing/paths'

class UserManagementDetailsAdd extends PureComponent {
  constructor(props) {
    super(props)

    this.userManagementDetailsAddFormSubmit = this.userManagementDetailsAddFormSubmit.bind(
      this,
    )
    this.userManagementDetailsAddFormSuccess = this.userManagementDetailsAddFormSuccess.bind(
      this,
    )
  }

  renderBreadcrumbs() {
    return (
      <div>
        <Breadcrumbs icon={<UserManagementIcon style={{ width: 24 }} />} />
        <Breadcrumb
          data={{
            title: 'User management',
            pathname: `${PATHS.main.dashboard}${
              PATHS.dashboard.userManagement
            }`,
          }}
        />
        <Breadcrumb
          data={{
            title: 'Create',
            pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
              PATHS.dashboard.userManagement
            }`,
          }}
        />
      </div>
    )
  }

  handleUpdateAfterCreate({ id }, values) {
    const { uploadProfileImage, updateUserById } = this.props
    const callbacks = {
      onSuccess: this.userManagementDetailsAddFormSuccess,
    }

    uploadProfileImage(id, get(values, 'profilePicture[0]'), {
      onSuccess: imageUrl =>
        updateUserById(id, { profile_picture: imageUrl }, callbacks),
    })
  }

  userManagementDetailsAddFormSubmit(values) {
    const { createUser } = this.props

    const payload = {
      first_name: values.firstName,
      last_name: values.lastName,
      mobile_phone: values.mobilePhone,
      email: values.email,
      password: values.password,
      business_number: values.businessNumber,
      role: values.role,
      status: values.status,
      is_verified: 1,
      profile_picture: undefined,
    }

    if (isClientRole(payload.role)) {
      payload.client_id = values.clientId
    } else {
      payload.city_id = values.cityId
    }

    if (values.profilePicture) {
      const callbacks = {
        onSuccess: res => this.handleUpdateAfterCreate(res, values),
      }
      createUser(payload, callbacks)
    } else {
      const callbacks = {
        onSuccess: this.userManagementDetailsAddFormSuccess,
      }
      createUser(payload, callbacks)
    }
  }

  userManagementDetailsAddFormSuccess() {
    const { history } = this.props

    history.push(`${PATHS.main.dashboard}${PATHS.dashboard.userManagement}`)
  }

  render() {
    return (
      <LayoutDashboard>
        {this.renderBreadcrumbs()}
        <UserDetailsWrapper>
          <UserManagementDetailsAddForm
            onSubmit={this.userManagementDetailsAddFormSubmit}
          />
        </UserDetailsWrapper>
      </LayoutDashboard>
    )
  }
}

UserManagementDetailsAdd.propTypes = {
  createUser: PropTypes.func.isRequired,
  updateUserById: PropTypes.func.isRequired,
  uploadProfileImage: PropTypes.func.isRequired,
}

export default connect(
  null,
  {
    createUser,
    updateUserById,
    uploadProfileImage,
  },
)(UserManagementDetailsAdd)



// WEBPACK FOOTER //
// ./src/Containers/UserManagement/UserDetails/Add/index.js